// extracted by mini-css-extract-plugin
module.exports = {"link":"link-a6113708"};